import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { BehaviorSubject, EMPTY } from 'rxjs';

import * as d3 from 'd3';
import { mApplicationUsage } from '../model/userUsage.model';

import { environment } from '../../environments/environment';
import { stringify } from '@angular/compiler/src/util';
import { Subscription } from 'rxjs';

@Injectable()
export class applicationUsageDataService {
  headers: any;
  options: any;
  private date$Filter = new BehaviorSubject<any>({
    startDate: '2019-08-20T00:00:00Z',
    endDate: '2019-08-21T00:00:00Z'
  });
  currentDateFilter = this.date$Filter.asObservable();

  private other$Filter = new BehaviorSubject<any>({});
  currentOtherFilters = this.other$Filter.asObservable();

  // device usage data
  private rawApplicationUsage$Data = new BehaviorSubject<mApplicationUsage[]>([]);
  readonly applicationUsage$Data = this.rawApplicationUsage$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawApplicationOverview$Data = new BehaviorSubject<any[]>([]);
  readonly applicationOverview$Data = this.rawApplicationOverview$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawApplicationOverviewTab$Data = new BehaviorSubject<any[]>([]);
  readonly applicationOverviewTab$Data = this.rawApplicationOverviewTab$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawApplicationDailyTrend$Data = new BehaviorSubject<any[]>([]);
  readonly applicationDailyTrend$Data = this.rawApplicationDailyTrend$Data.asObservable();

  // inventory
  private rawApplicationInventory$Data = new BehaviorSubject<any[]>([]);
  readonly applicationInventory$Data = this.rawApplicationInventory$Data.asObservable();
  private dateFilter:Subscription;
  private appInvDateFilter:Subscription;
  constructor( private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
  }

  setDateFilter(start, end?) {

    if (start) {
      if (start && end) {
        this.date$Filter.next(Object.assign({}, {
          startDate: start + 'T00:00:00Z',
          endDate: end + 'T00:00:00Z'
        }));
      } else {
        let startDate: string;
        let endDate: string;
        const curDate = new Date();
        endDate = curDate.getFullYear() + '-' + ('0' + (curDate.getMonth() + 1)).slice(-2) + '-' + ('0' + curDate.getDate()).slice(-2) + 'T00:00:00Z';

        let diffInHours = 0;
        if (start === '24Hours') {
          diffInHours = 24 * 3600;
        } else if (start === '7Days') {
          diffInHours = 7 * (24 * 3600);
        } else if (start === '30Days') {
          diffInHours = 30 * (24 * 3600);
        } else if (start === '90Days') {
          diffInHours = 90 * (24 * 3600);
        } else if (start === 'Year') {
          diffInHours = 365 * (24 * 3600);
        }

        const tmpDate = new Date(curDate.getTime() - (diffInHours * 1000));
        startDate = tmpDate.getFullYear() + '-' + ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + ('0' + tmpDate.getDate()).slice(-2) + 'T00:00:00Z';

        this.date$Filter.next(Object.assign({}, {
          startDate,
          endDate
        }));

      }
    }
  }

  setOtherFilter(filter: any) {
    if (filter) {
      this.other$Filter.next(Object.assign({}, filter));
    } else {
      this.other$Filter.next(Object.assign({}, EMPTY));
    }
  }


  // Get ApplicationUsageData from server | HTTP GET
  loadApplicationUsageData() {
    let count = 0;
    // toto: add all data filter
    if(this.dateFilter){
      this.dateFilter.unsubscribe();
    }
    this.dateFilter = this.currentDateFilter.subscribe( data => {
      const startDate = data.startDate;
      const endDate = data.endDate;
    
      let URLSearchParams = new HttpParams();
      count= count+1;
      URLSearchParams = URLSearchParams.set('startDate', startDate);
      URLSearchParams = URLSearchParams.set('endDate', endDate);

      this.options = { headers: this.headers, params: URLSearchParams };
      //if(count==1){
      this.http.get(environment.dashAPI + '/application', this.options).subscribe( data1 => {
        try {
          this.rawApplicationUsage$Data.next(Object.assign([], data1));
        } catch (err) {
          this.rawApplicationUsage$Data.next(Object.assign([], EMPTY));
          this.clearUserCache();
        }
      }, error => {
        // console.log('Could not load todos.');
        this.rawApplicationUsage$Data.next(Object.assign([], EMPTY));
        this.clearUserCache();
      });
    //}
    });
  }

  // Clear configs
  clearUserCache() {
    this.rawApplicationUsage$Data.next(Object.assign([], EMPTY));
    this.rawApplicationOverview$Data.next(Object.assign([], EMPTY));
    this.rawApplicationOverviewTab$Data.next(Object.assign([], EMPTY));
    this.rawApplicationDailyTrend$Data.next(Object.assign([], EMPTY));
    this.rawApplicationInventory$Data.next(Object.assign([], EMPTY));
  }

  // overview tab and devices tab
  getApplicationOverviewData() {
    this.applicationUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {
          if (filter) {
            filterredData = data.filter((item) => {
              for (const key in filter) {
                if (item[key] === undefined || item[key] !== filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {

            const tmpData1 = d3.nest<mApplicationUsage, number>()
              .key((d: any) => d.app_name)
              .rollup((v) => {
                return d3.sum(v, (g: any) => parseInt(g.usage_duration_hours));
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            const tmpData2 = d3.nest<mApplicationUsage, number>()
              .key((d: any) => d.app_name)
              .rollup((v) => {
                return d3.sum(v, (g: any) => parseInt(g.sno_of_users));
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            // console.log("tmpData >>> " + JSON.stringify(tmpData1));
            let i;
            let tmpData = [];
            for (i = 0; i < tmpData1.length; i++){
              tmpData[i] = {};
              tmpData[i].id = tmpData1[i].key;
              tmpData[i].usage_hours = tmpData1[i].value;
              if (tmpData1[i].key === tmpData2[i].key && tmpData2[i].value) {
                  tmpData[i].user_count = tmpData2[i]['value'];
                }
                else {
                  tmpData[i].used = 0;
                }
            }

            tmpData.sort((a, b) =>{
              return b.usage_hours - a.usage_hours;
            });
            // console.log("tmpData >>> " + JSON.stringify(tmpData));

            const j = 0;
            const tmp = [];
            for (i = 0; i < tmpData.length; i++){
              if (i < 2) {
                tmp[i] = {};
                tmp[i].id = tmpData[i].id;
                tmp[i].count = tmpData[i].usage_hours;
              } else {
                if (i === 2) {
                  tmp[i] = {};
                  tmp[i].id = 'Other Apps (Combined)';
                  tmp[i].count = 0;
                }
                tmp[2].count = tmp[2].count + tmpData[i].usage_hours;
              }
            }

            // console.log("tmp >>> " + JSON.stringify(tmp));

            this.rawApplicationOverview$Data.next(Object.assign([], tmp));
            this.rawApplicationOverviewTab$Data.next(Object.assign([], tmpData));
          } else {
            this.rawApplicationOverview$Data.next(Object.assign([], EMPTY));
            this.rawApplicationOverviewTab$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawApplicationOverview$Data.next(Object.assign([], EMPTY));
        this.rawApplicationOverviewTab$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getApplicationDailyTrendData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.applicationUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (let key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mApplicationUsage, number>()
              .key(function(d: any) { return d.app_name; })
              .key(function(d: any) { return d.activity_date; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.sno_of_users); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);
            // console.log("trend data >>> " + JSON.stringify(tmpData));

            let j;
            let mData = [];
            for (j = 0; j < tmpData.length; j++){
              mData[j] = {};
              mData[j].id = tmpData[j].key;
              mData[j].total_users = d3.sum(tmpData[j].values, function(g: any) { return parseInt(g.value); });
              // mData[j].values = tmpData[j].values;
              if (tmpData[j].values) {
                let n = 0;
                mData[j].values = [];
                for (n = 0; n < tmpData[j].values.length; n++) {
                  let from = tmpData[j].values[n].key.split('-');
                  // var f = new Date(from[2], from[1] - 1, from[0])
                  let mydate = new Date(from[2], from[1] - 1, from[0], 0, 0, 0);
                  mData[j].values.push({
                    date: mydate,
                    count: tmpData[j].values[n].value
                  });
                }
                // delete tmpData[i].values;
              }
            }

            mData.sort((a, b) => {
              return b.total_users - a.total_users;
            });

            let i;
            const result: any[] = [];
            for (i = 0; i < mData.length; i++){
              if (i === 0) {
                result[i] = {};
                result[i].id = 'Most popular';
                result[i].values = mData[i].values;
              } else if (i === 1) {
                result[i] = {};
                result[i].id = '2nd most popular';
                result[i].values = mData[i].values;
              } else if (i === 2) {
                result[i] = {};
                result[i].id = 'Other apps (combined)';
                result[i].values = mData[i].values;
              } else {
                result[2].values.concat(mData[i].values);
              }
            }

            // console.log("Per trend data >>> " + JSON.stringify(result));
            this.rawApplicationDailyTrend$Data.next(Object.assign([], result));
          } else {
            this.rawApplicationDailyTrend$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawApplicationDailyTrend$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // device tab
  getApplicationInventoryData() {
    // toto: add all data filter
    let count=0;
    if(this.appInvDateFilter){
      this.appInvDateFilter.unsubscribe();
    }
    this.appInvDateFilter = this.currentDateFilter.subscribe( data => {
      const startDate = data.startDate;
      const endDate = data.endDate;
      let URLSearchParams = new HttpParams();
     count= count+1;
      URLSearchParams = URLSearchParams.set('startDate', startDate);
      URLSearchParams = URLSearchParams.set('endDate', endDate);

      this.options = { headers: this.headers, params: URLSearchParams };
      //if(count==1){
      this.http.get(environment.dashAPI + '/appinventory', this.options).subscribe(data1 => {
        try {
          this.rawApplicationInventory$Data.next(Object.assign([], data1));
        } catch (err) {
          this.rawApplicationInventory$Data.next(Object.assign([], EMPTY));
          this.clearUserCache();
        }
      }, error => {
        // console.log('Could not load todos.');
        this.rawApplicationInventory$Data.next(Object.assign([], EMPTY));
        this.clearUserCache();
      });
      //}
    });
  }

  // end
}
